import http from '../../../../api/http'
import { useSasTokenStore } from "../../../../stores/sasTokenStore";

function retrieveList(paramObj) { // 목록 조회
    return http.post('/lecture/notice/retrieveAllPaging', {
        lectId: paramObj.lectId, //  0,
        boardGb: paramObj.boardGb || "NOTICE",
        myPostGb: paramObj.myPostGb, // "string",
        createId: paramObj.createId, // 0,
        pageNumber: paramObj.pageNo, // 0,
        size: paramObj.size || 30,
        searchType: paramObj.searchType, // "string",
        searchInput: paramObj.searchInput, // "string"
    })
}

function retrieveDetail(paramObj) { // 상세 조회
    return http.post('/lecture/notice/retrieve', {
        lectId: paramObj.lectId,
        boardId: paramObj.boardId,
    })
}

function createNotice(paramObj) { // 생성
    const store = useSasTokenStore();
    const sasToken = store.sasToken;
    store.sasToken = '';

    return http.post('/lecture/notice/create', {
        boardId: paramObj.boardId, // 0,
        lectId: paramObj.lectId, // 0,
        boardGb: paramObj.boardGb || "NOTICE",
        title: paramObj.title, // "string",
        content: paramObj.content, // "string",
        secretYn: paramObj.secretYn, // "string",
        answer: paramObj.answer, // "string",
        hitCount: paramObj.hitCount, // 0,
        createId: paramObj.createId, // 0,
        attachList: paramObj.attachList, // [],
        securePdfList: paramObj.securePdfList, // [],
        sasToken,
    })
}

function updateNotice(paramObj) { // 수정
    const store = useSasTokenStore();
    const sasToken = store.sasToken;
    store.sasToken = '';

    return http.post('/lecture/notice/update', {
        boardId: paramObj.boardId, // 0,
        lectId: paramObj.lectId, // 0,
        boardGb: paramObj.boardGb || "NOTICE",
        title: paramObj.title, // "string",
        content: paramObj.content, // "string",
        secretYn: paramObj.secretYn, // "string",
        answer: paramObj.answer, // "string",
        hitCount: paramObj.hitCount, // 0,
        createId: paramObj.createId, // 0,
        attachList: paramObj.attachList, // [],
        securePdfList: paramObj.securePdfList, // [],
        sasToken,
    })
}

function deleteNotice(paramObj) { // 삭제
    return http.post('/lecture/notice/delete', {
        lectId: paramObj.lectId,
        boardId: paramObj.boardId,
    })
}

export default {
    retrieveList,
    retrieveDetail,
    createNotice,
    updateNotice,
    deleteNotice
}